import { render, staticRenderFns } from "./NavSearchResultsPages.vue?vue&type=template&id=57d6146f"
import script from "./NavSearchResultsPages.vue?vue&type=script&lang=js"
export * from "./NavSearchResultsPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports